import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import CardGrid from '../../CardGrid/CardGrid';

export const Heading = styled.h2`
  ${fonts.headingMedium}
  text-align: left;
  margin-bottom: 0;
  margin-top: ${spacing(5)};
  font-weight: 700;
  color: ${colors.neutral01};
`;

export const Intro = styled.p`
  ${fonts.paragraph};
  margin-top: ${spacing(2)};
  margin-bottom: 0;
`;

export const StyledCardGrid = styled(CardGrid)`
  > * {
    display: none;
  }

  > *:nth-child(-n + 3) {
    display: flex;
  }

  ${mediaQuery.tabletPortrait`
    > *:nth-child(-n + 4) {
        display: flex;
    }
  `}

  ${mediaQuery.desktop`
    > *:nth-child(n + 4) {
      display: none;
    }
  `}
`;
